import axios from "axios";
import { Payload } from "../types";

const API_URL = import.meta.env.VITE_APP_API_URL;
const CSV_UPLOAD_URL = API_URL + import.meta.env.VITE_APP_CSV_UPLOAD;
const CSV_ALL_REGIONS_URL = API_URL + import.meta.env.VITE_APP_ALL_REGIONS;
const CSV_METRIC_FILTER_URL = API_URL + import.meta.env.VITE_APP_METRIC_FILTER;
const GET_USER_ROLE_URL = API_URL + import.meta.env.VITE_APP_USER_ROLE;
const GET_PREDICTION_URL = API_URL + import.meta.env.VITE_APP_PREDICTOR;
const GET_PREDICTION_HISTOGRAM_URL =
  API_URL + import.meta.env.VITE_APP_PREDICTOR_HISTOGRAM;

const email = "rijusaha1234@gmail.com";

export const uploadCSVData = async (payload: Payload): Promise<any> => {
  try {
    const response = await axios.post(CSV_UPLOAD_URL, payload, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
        email: email,
        // ${localStorage.getItem("token")}`
      },
      // withCredentials: true,
    });
    console.log(response);

    return response.status;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};

export const getInitialData = async (
  lat: number | null,
  long: number | null
): Promise<any> => {
  try {
    // Append `region` as a query parameter if provided
    const url =
      lat !== undefined && lat !== null
        ? `${CSV_ALL_REGIONS_URL}?latitude=${lat}&longitude=${long}`
        : CSV_ALL_REGIONS_URL;

    const response = await axios.get(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });

    return response.data;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};

export const getGraphData = async (
  ID: string,
  metric: string
): Promise<any> => {
  try {
    const url = `${CSV_METRIC_FILTER_URL}?ID=${ID}&metric=${metric}`;

    const response = await axios.get(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};

export const getUserRole = async (): Promise<any> => {
  try {
    const response = await axios.get(GET_USER_ROLE_URL, {
      headers: {
        "ngrok-skip-browser-warning": "true",
        email: email,
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};

export const getPredictionData = async (modelId: string): Promise<any> => {
  try {
    const url = `${GET_PREDICTION_URL}?code=${modelId}`;

    const response = await axios.get(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};

export const getPredictionHistogramData = async (
  modelId: string
): Promise<any> => {
  try {
    const url = `${GET_PREDICTION_HISTOGRAM_URL}?code=${modelId}`;

    const response = await axios.get(url, {
      headers: {
        "ngrok-skip-browser-warning": "true",
      },
    });
    const imageUrl = API_URL + response.data.image_path.image_url;
    return imageUrl;
  } catch (error: any) {
    console.error("Axios Error:", error.response || error.message);
    throw error;
  }
};
